import React, { useState, useRef, useCallback } from "react";

export const BeforeAfterSlider = ({ before, after, beforeLabel = "Before", afterLabel = "After" }) => {
  const [pos, setPos] = useState(50);
  const containerRef = useRef(null);
  const dragging = useRef(false);

  const move = useCallback((clientX) => {
    if (!containerRef.current) return;
    const rect = containerRef.current.getBoundingClientRect();
    let p = ((clientX - rect.left) / rect.width) * 100;
    p = Math.max(0, Math.min(100, p));
    setPos(p);
  }, []);

  const onDown = () => { dragging.current = true; };
  const onUp = () => { dragging.current = false; };
  const onMove = (e) => {
    if (!dragging.current) return;
    const clientX = e.touches ? e.touches[0].clientX : e.clientX;
    move(clientX);
  };

  return (
    <div
      ref={containerRef}
      data-testid="before-after-slider"
      className="relative w-full aspect-[3/4] max-h-[560px] overflow-hidden rounded-2xl select-none cursor-ew-resize bg-brand-sand"
      onMouseMove={onMove}
      onMouseUp={onUp}
      onMouseLeave={onUp}
      onTouchMove={onMove}
      onTouchEnd={onUp}
    >
      <img src={after} alt="after" className="absolute inset-0 w-full h-full object-cover" draggable={false} />
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
        <img
          src={before}
          alt="before"
          className="absolute inset-0 h-full object-cover"
          style={{ width: containerRef.current ? containerRef.current.getBoundingClientRect().width : "100%", maxWidth: "none" }}
          draggable={false}
        />
      </div>
      <div className="absolute top-4 left-4 px-3 py-1 rounded-full bg-black/40 backdrop-blur-sm text-white text-xs font-body tracking-wide">{beforeLabel}</div>
      <div className="absolute top-4 right-4 px-3 py-1 rounded-full bg-brand-primary/80 backdrop-blur-sm text-white text-xs font-body tracking-wide">{afterLabel}</div>
      <div
        className="absolute top-0 bottom-0 flex items-center justify-center"
        style={{ left: `calc(${pos}% - 1px)` }}
      >
        <div className="w-0.5 h-full bg-brand-accent shadow-lg" />
        <div
          className="absolute w-11 h-11 rounded-full bg-white border-2 border-brand-accent shadow-xl flex items-center justify-center cursor-ew-resize"
          onMouseDown={onDown}
          onTouchStart={onDown}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#B89C72" strokeWidth="2">
            <path d="M8 7l-5 5 5 5M16 7l5 5-5 5" />
          </svg>
        </div>
      </div>
    </div>
  );
};
